// src/helpers/chunkUtils.js
import { addMonths, addDays, isAfter, max as dateMax, min as dateMin, differenceInMonths } from "date-fns";

export const CHUNK_MONTHS = 3; // チャンク処の幅（月数）

/**
// // chunk を有効にするのは company_id が big_companies に含まれるとき
// // かつ（期間 >= 3か月）かつ（comment = 1 または status が指定）
 */
export function isChunkEligible(companyId, startDateStr, endDateStr, searchComment, status, bigCompanies = null, failureId) {
  try {
    const s = new Date(startDateStr);
    const e = new Date(endDateStr);
    const months = differenceInMonths(e, s);

    const hasComment = (searchComment === 1 || searchComment === '1');
    const hasStatus = !(status === null || status === "" || typeof status === "undefined");
    const isFailureMode = (failureId === 1 || failureId === '1');

    // bigCompanies が指定されている場合 → companyId が bigCompanies に含まれているか確認
    if (Array.isArray(bigCompanies) && bigCompanies.length > 0) {
      const set = new Set(bigCompanies.map(String));
      const inBig = set.has(String(companyId));
      return inBig && months >= CHUNK_MONTHS && (hasComment || hasStatus || isFailureMode);
    }

    // bigCompanies が指定されていない場合 → 期間と comment/status のみをチェック
    return months >= CHUNK_MONTHS && (hasComment || hasStatus || isFailureMode);
  } catch {
    return false;
  }
}

/**
 * 期間を連続する3か月ウィンドウに分割する
 */
export function splitIntoQuarterWindows(startDateStr, endDateStr) {
  const windows = [];
  let curStart = new Date(startDateStr);
  const end = new Date(endDateStr);

  while (!isAfter(curStart, end)) {
    const curEnd = dateMin([addMonths(curStart, CHUNK_MONTHS), end]);
    windows.push([curStart, curEnd]);
    curStart = addDays(curEnd, 1);
  }
  return windows;
}

/**
 * 期間を連続する3か月ウィンドウに分割（後ろから）
 */
export function splitIntoQuarterWindowsBackward(startDateStr, endDateStr) {
  const windows = [];
  const start = new Date(startDateStr);
  let curEnd = new Date(endDateStr);

  while (!isAfter(start, curEnd)) {
    const curStart = dateMax([addMonths(curEnd, -CHUNK_MONTHS), start]);
    windows.push([curStart, curEnd]);
    curEnd = addDays(curStart, -1);
  }
  return windows;
}
